const global = {
	azure100: '#E5EFFF',
	azure200: '#B2CFFF',
	azure300: '#7EAEFF',
	azure400: '#4A8CFF',
	azure500: '#1769FF',
	azure600: '#0059FD',
	azure700: '#0051E4',
	azure800: '#0048CB',
	azure900: '#003FB2',
	black: '#000000',
	blue100: '#E5F1F7',
	blue200: '#B8D4E8',
	blue300: '#8CB4D7',
	blue400: '#618FC6',
	blue500: '#4169AA',
	blue600: '#3F629E',
	blue700: '#3C5C93',
	blue800: '#3A5587',
	blue900: '#374F7C',
	bronze100: '#F9F1E3',
	bronze200: '#EFD098',
	bronze300: '#EDB346',
	bronze400: '#D5900A',
	bronze500: '#8B5D00',
	bronze600: '#805706',
	bronze700: '#76510C',
	bronze800: '#6C4B11',
	bronze900: '#634616',
	green100: '#E4F4EE',
	green200: '#99E3BC',
	green300: '#41DF72',
	green400: '#0EB528',
	green500: '#006700',
	green600: '#0A6005',
	green700: '#13590A',
	green800: '#1A520F',
	green900: '#204B13',
	grey100: '#FAFAFA',
	grey200: '#F6F6F6',
	grey300: '#EDEDED',
	grey400: '#D3D3D3',
	grey500: '#BABABA',
	grey600: '#A0A0A0',
	grey700: '#878787',
	grey800: '#6E6E6E',
	grey900: '#545454',
	grey1000: '#212121',
	pink100: '#FEF3F9',
	pink200: '#FAB2DA',
	pink300: '#F96EBB',
	pink400: '#FB289C',
	pink500: '#DE007B',
	pink600: '#D10073',
	pink700: '#C3006C',
	pink800: '#B60064',
	pink900: '#A8005D',
	purple100: '#FBF4FB',
	purple200: '#E6B7E5',
	purple300: '#D178D0',
	purple400: '#BA3CB8',
	purple500: '#7D277B',
	purple600: '#752474',
	purple700: '#6E226C',
	purple800: '#661F65',
	purple900: '#5E1D5D',
	red100: '#FFEFEF',
	red200: '#FDB0B0',
	red300: '#F97375',
	red400: '#F3393D',
	red500: '#D91218',
	red600: '#C71617',
	red700: '#B61A19',
	red800: '#A51F1B',
	red900: '#95231D',
	white: '#FFFFFF',
};

const brand = {
	littlewoods: {
		enhancedText: global.white,
		onBlack: global.white,
		purple100: global.purple100,
		purple200: global.purple200,
		purple300: global.purple300,
		purple400: global.purple400,
		purple500: global.purple500,
		purple600: global.purple600,
		purple700: global.purple700,
		purple800: global.purple800,
		purple900: global.purple900,
		purpleDark: global.purple900,
		purpleMid: global.purple500,
		purpleLight: global.purple100,
	},
	very: {
		enhancedText: global.black,
		onBlack: global.pink500,
		pink100: global.pink100,
		pink200: global.pink200,
		pink300: global.pink300,
		pink400: global.pink400,
		pink500: global.pink500,
		pink600: global.pink600,
		pink700: global.pink700,
		pink800: global.pink800,
		pink900: global.pink900,
		pinkDark: global.pink900,
		pinkMid: global.pink500,
		pinkLight: global.pink100,
	},
};

const universal = {
	blueDark: global.blue900,
	blueMid: global.blue500,
	blueLight: global.blue100,
	bronzeDark: global.bronze900,
	bronzeMid: global.bronze500,
	bronzeLight: global.bronze100,
	greenDark: global.green900,
	greenMid: global.green500,
	greenLight: global.green100,
	redDark: global.red900,
	redMid: global.red500,
	redLight: global.red100,
};

const functional = {
	divider: global.grey400,
	errorDark: universal.redDark,
	errorMid: universal.redMid,
	errorLight: universal.redLight,
	focus: global.azure500,
	informationDark: universal.blueDark,
	informationMid: universal.blueMid,
	informationLight: universal.blueLight,
	page: global.white,
	panelDark: global.grey200,
	panelMid: global.grey100,
	panelLight: global.white,
	successDark: universal.greenDark,
	successMid: universal.greenMid,
	successLight: universal.greenLight,
	tintBlack10: 'rgba(0,0,0,0.1)',
	tintBlack20: 'rgba(0,0,0,0.2)',
	tintBlack90: `${global.black}e5`,
	tintWhite20: 'rgba(f,f,f,0.2)',
	tintWhite90: `${global.white}e5`,
	tintRed90: `${universal.redMid}e5`,
	warningDark: universal.bronzeDark,
	warningMid: universal.bronzeMid,
	warningLight: universal.bronzeLight,
};

export { brand, functional, global, universal };
